export default __webpack_public_path__ + "static/10-114eb37fd8f6118f7d4b02de0a533241.webp";